import {register} from 'dna-react-ioc'
import {FooterStoreSymbol} from '@/components'
import {FooterStore} from '@/stores/footer/FooterStore'
import {TFooterStore} from '@/components/composite/Footer/TFooterStore'

export const footerInitState = () => {
    register<TFooterStore>(FooterStoreSymbol).to(FooterStore).inSingletonScope()
}
